import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { FilePdfOutlined, DownloadOutlined } from '@ant-design/icons';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import AssetPDFDocument from './AssetPDFDocument';
import { Asset } from '../types';

const ExportAssetPDFButton: React.FC<{
  asset: Asset;
  companies: any[];
  categories: any[];
  locations: any[];
  suppliers: any[];
  employees: any[];
  maintenanceTypes?: any[];
  style?: React.CSSProperties;
  qrBase64?: string;
  barcodeBase64?: string;
}> = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        icon={<FilePdfOutlined />}
        style={{ float: 'right', marginBottom: 8, padding: '6px 16px', background: '#1677ff', color: '#fff', borderRadius: 4, fontWeight: 500, textDecoration: 'none', ...(props.style || {}) }}
        onClick={() => setOpen(true)}
      >
        Xem PDF
      </Button>
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <PDFDownloadLink
            key="download"
            document={<AssetPDFDocument {...props} qrBase64={props.qrBase64} barcodeBase64={props.barcodeBase64} />}
            fileName={`Thong_tin_tai_san_${props.asset.asset_code || 'unknown'}.pdf`}
          >
            {({ loading }) => (
              <Button
                icon={<DownloadOutlined />}
                type="primary"
                disabled={loading}
                style={{ marginRight: 8 }}
              >
                {loading ? 'Đang tạo...' : 'Tải PDF'}
              </Button>
            )}
          </PDFDownloadLink>,
          <Button key="close" onClick={() => setOpen(false)}>Đóng</Button>
        ]}
        width={900}
        style={{ top: 24 }}
        styles={{ body: { height: 700, padding: 0 } }}
      >
        <PDFViewer width="100%" height={650} showToolbar={true}>
          <AssetPDFDocument {...props} qrBase64={props.qrBase64} barcodeBase64={props.barcodeBase64} />
        </PDFViewer>
      </Modal>
    </>
  );
};

export default ExportAssetPDFButton; 